"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrToTree = arrToTree;
exports.generateRandomNum = exports.generateNumberArray = exports.formatNumber = exports.currency = exports.calc = void 0;
exports.generateUuid = generateUuid;
exports.pickDomAttrs = exports.isChineseCharReg = exports.getCharLength = void 0;
exports.sortWithKey = sortWithKey;
exports.toSorted = toSorted;
exports.treeToArr = treeToArr;
var _nanoid = require("nanoid");
var _ramda = require("ramda");
var _calc = require("./calc");
var _defineType = require("./defineType");
const calc = exports.calc = {
  add: _calc.add,
  div: _calc.div,
  mul: _calc.mul,
  pow: _calc.pow,
  sub: _calc.sub,
  toFixed: _calc.toFixed
};

/**
 * 生成一个唯一id
 */
function generateUuid(length, alphabet) {
  if ((0, _defineType.isNumber)(length) && length < 0) {
    throw new Error('[generateUuid]: length should be greater than 0');
  }
  const l = (0, _defineType.isNumber)(length) && length > 0 ? length : undefined;
  if (alphabet) {
    const customNanoid = (0, _nanoid.customAlphabet)(alphabet);
    return customNanoid(l);
  }
  return (0, _nanoid.nanoid)(l);
}

// 正向-树形结构转平铺
// 从外到内依次递归，有 children 则继续递归
function treeToArr() {
  let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let rowKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
  let pid = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  let res = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  data.forEach(item => {
    res.push({
      _pid: pid,
      ...item
    });
    if (item.children && item.children.length !== 0) {
      treeToArr(item.children, rowKey, item[rowKey], res);
    }
  });
  return res;
}

// 依次在数组中找到每一层级对应的元素，同时每个元素的 children 属性对应的 value 通过 pid 去找到，然后递归执行下去
function arrToTree() {
  let arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let rowKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'id';
  let pid = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  const res = [];
  arr.forEach(item => {
    if (item._pid === pid) {
      // 这样每次都需要遍历整个数组，因此时间复杂度为 n*n
      // const children = arrToTree(arr, item.id)

      // 往下递归时，每次数组的大小都在减小，每次都筛选掉父代元素，最终的时间复杂度为 n*logn
      const children = arrToTree(arr.filter(v => v._pid !== pid), rowKey, item[rowKey]);
      if (children.length) {
        res.push({
          ...item,
          children
        });
      } else {
        res.push({
          ...item
        });
      }
    }
  });
  return res;
}
const formatNumber = (value, option) => {
  var _option$comma, _option$addZero;
  value = (0, _defineType.isNone)(value) ? NaN : Number(value);
  if (!(0, _defineType.isNumber)(value)) {
    return '';
  }
  const comma = (_option$comma = option === null || option === void 0 ? void 0 : option.comma) !== null && _option$comma !== void 0 ? _option$comma : true;
  const addZero = (_option$addZero = option === null || option === void 0 ? void 0 : option.addZero) !== null && _option$addZero !== void 0 ? _option$addZero : 2;
  let [integer, decimal] = value.toString().split('.');
  if (comma) {
    integer = integer.replace(/(?=\B(\d{3})+$)/g, ',');
  }
  if (addZero > 0) {
    var _decimal;
    decimal = ((_decimal = decimal) !== null && _decimal !== void 0 ? _decimal : '').padEnd(addZero, '0');
  }
  return decimal ? [integer, decimal].join('.') : integer;
};

/**
 * 格式化金额（会自动向上保留3位小数，如：1200.123456 => 1,200.124）
 * @param value 需要格式化的金额
 * @param option.precision 保留小数位数
 * @param option.addZero 是否需要在末尾补0, 默认2位
 * @param option.type 保留小数的方式：ceil | floor | round
 */
exports.formatNumber = formatNumber;
const currency = (value, option) => {
  try {
    var _option$precision, _option$mode, _option$addZero2;
    if (!(0, _defineType.isNumber)(value)) {
      throw new Error('currency value is not a number');
    }
    const result = (0, _calc.toFixed)(value, {
      precision: (_option$precision = option === null || option === void 0 ? void 0 : option.precision) !== null && _option$precision !== void 0 ? _option$precision : 3,
      mode: (_option$mode = option === null || option === void 0 ? void 0 : option.mode) !== null && _option$mode !== void 0 ? _option$mode : 'ceil'
    });
    return formatNumber(result, {
      comma: true,
      addZero: (_option$addZero2 = option === null || option === void 0 ? void 0 : option.addZero) !== null && _option$addZero2 !== void 0 ? _option$addZero2 : 2
    });
  } catch (error) {
    console.error(error);
    return '';
  }
};

/**
 * 生成指定范围内的随机数
 * @param option.min 最小值
 * @param option.max 最大值
 */
exports.currency = currency;
const generateRandomNum = option => {
  var _option$min, _option$max, _option$precision2;
  const min = (_option$min = option === null || option === void 0 ? void 0 : option.min) !== null && _option$min !== void 0 ? _option$min : 0;
  const max = (_option$max = option === null || option === void 0 ? void 0 : option.max) !== null && _option$max !== void 0 ? _option$max : 100;
  const precision = (_option$precision2 = option === null || option === void 0 ? void 0 : option.precision) !== null && _option$precision2 !== void 0 ? _option$precision2 : 2;
  const random = Math.random() * (max - min) + min;
  const multiplier = Math.pow(10, precision);
  return Math.round(random * multiplier) / multiplier;
};

/**
 * 对象数组按指定字段值排序
 * @param key
 * @param list
 * @returns
 */
exports.generateRandomNum = generateRandomNum;
function sortWithKey(key, list) {
  if (!list) {
    return [];
  }
  return list.sort((next, current) => {
    const cv = current === null || current === void 0 ? void 0 : current[key];
    const nv = next === null || next === void 0 ? void 0 : next[key];
    if (typeof cv === 'string') {
      return typeof nv === 'string' || (0, _defineType.isNumber)(nv) ? nv.toString() === cv ? -1 : nv.toString().localeCompare(cv) : 0;
    }
    if ((0, _defineType.isNumber)(cv)) {
      return typeof nv === 'string' ? nv === cv.toString() ? 0 : nv.localeCompare(cv.toString()) : (0, _defineType.isNumber)(nv) ? nv - cv : 0;
    }
    return typeof nv === 'string' || (0, _defineType.isNumber)(nv) ? -1 : 0;
  });
}
function compare(cv, nv) {
  if ((0, _defineType.isString)(cv)) {
    return (0, _defineType.isString)(nv) || (0, _defineType.isNumber)(nv) ? String(nv) === cv ? -1 : String(nv).localeCompare(cv) : 0;
  }
  if ((0, _defineType.isNumber)(cv)) {
    return (0, _defineType.isString)(nv) ? nv === String(cv) ? 0 : nv.localeCompare(String(cv)) : (0, _defineType.isNumber)(nv) ? nv - cv : 0;
  }
  return (0, _defineType.isString)(nv) || (0, _defineType.isNumber)(nv) ? -1 : 0;
}
/**
 * 智能数组排序
 * 1. 将数字和字符串转化后比较
 * 2. 如果是对象数组，可以指定排序字段
 * @param list
 * @param key
 * @returns
 */
function toSorted(list, key) {
  if (!Array.isArray(list) || list.length === 0) {
    return [];
  }
  return (0, _ramda.clone)(list).sort((next, current) => {
    if (key) {
      const cv = current === null || current === void 0 ? void 0 : current[key];
      const nv = next === null || next === void 0 ? void 0 : next[key];
      return compare(cv, nv);
    }
    return compare(current, next);
  });
}

/**
 * 生成指定范围内的数组
 * @param min 开始数字
 * @param max 结束数字
 * @param excludes 排除数字
 * @returns
 */
const generateNumberArray = (min, max, excludes) => {
  const list = [];
  for (let v = min; v <= max; v++) {
    if (!(excludes !== null && excludes !== void 0 && excludes.includes(v))) {
      list.push(v);
    }
  }
  return list;
};

/**
 * \u4e00-\u9fa5：基本的中文字符
 * \u3000-\u303f：中文标点符号
 * \uff00-\uffef：全角字符和全角标点符号
 * \u201c-\u201d：中文双引号
 * \u2018-\u2019：中文单引号
 */
exports.generateNumberArray = generateNumberArray;
const isChineseCharReg = exports.isChineseCharReg = /[\u4e00-\u9fa5\u3000-\u303f\uff00-\uffef\u201c-\u201d\u2018-\u2019]/g;
/**
 * 获取字符串字符长度，中文算2个字节
 * * @param str 字符串
 */
const getCharLength = function () {
  let str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (typeof str !== 'string') {
    console.error('[getCharLength]:', str, 'is not a string!');
    return 0;
  }

  // str = str.replaceAll(isChineseCharReg, '¥Z');
  return str.length;
};
exports.getCharLength = getCharLength;
const pickDomAttrs = props => {
  const _props = (0, _defineType.isObject)(props) ? props : {};
  const data = {};
  const others = {};
  Object.entries(_props).forEach(_ref => {
    let [key, value] = _ref;
    if (key.startsWith('data-')) {
      data[key] = value;
    } else {
      others[key] = value;
    }
  });
  return {
    data,
    others
  };
};
exports.pickDomAttrs = pickDomAttrs;